import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { TextField } from 'formik-mui';
import { Formik, Field, Form, ErrorMessage, FieldArray } from 'formik';
// material
import { Stack, Typography, Button, Grid, FormLabel, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
//
import { request } from 'src/Redux/helpers/axiosRequest';
import SelectCategory from './SelectCategory';
import { addPageSection } from 'src/Redux/actions/pageSectionActions';
// Image Validation
const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/webp'];

export default function AddWhyUs() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // Get All Categories
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setLoading(true);
    request({
      url: `${process.env.REACT_APP_API_URL}/category/get-all`,
      method: 'GET',
      data: null
    })
      // .then((res) => res.json())
      .then(({ data }) => {
        setCategories(data.categories);
        setLoading(false);
      });
  }, []);

  return (
    <Grid container>
      <Grid lg={8} md={8} xs={10} sm={10} mx="auto" item>
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Formik
              enableReinitialize={true}
              initialValues={{
                sectionName: '',
                categoryId: '',
                sectionMeta: {
                  whyus_cols: [{ title: '', shortDescription: '', position: '', icon: '' }]
                }
              }}
              onSubmit={async (values) => {
                dispatch(addPageSection(values, navigate));
                setLoading(true);
                setTimeout(() => {
                  setLoading(false);
                }, 2000);
              }}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form autoComplete="off">
                  <Typography variant="h4" gutterBottom>
                    Add Why Us
                  </Typography>
                  <Stack spacing={1} mt={2}>
                    <FormLabel id="sectionName">Section Name</FormLabel>
                    <Field
                      type="text"
                      id="sectionName"
                      name="sectionName"
                      className="input-style"
                      placeholder="Enter Seciont Name"
                      required
                    />
                    {errors.sectionName && touched.sectionName ? (
                      <div className="error-color">{errors.sectionName}</div>
                    ) : null}
                    <FormLabel id="categoryId">Section Category</FormLabel>
                    <SelectCategory categories={categories} name="categoryId" />
                    <h2 className="mt-5">Why Us Columns</h2>
                    {values.sectionMeta?.whyus_cols?.length &&
                      values.sectionMeta?.whyus_cols?.map((items, idx) => {
                        return (
                          <FieldArray name="sectionMeta.whyus_cols">
                            {({ remove, push }) => (
                              <>
                                <div className="row" key={idx}>
                                  <div className="col">
                                    <Button
                                      type="button"
                                      variant="contained"
                                      color="secondary"
                                      sx={{ mb: 2 }}
                                      onClick={() =>
                                        push({ title: '', shortDescription: '', position: '' })
                                      }
                                    >
                                      Add Section
                                    </Button>
                                    {idx !== 0 && (
                                      <Button
                                        type="button"
                                        sx={{ ml: 2, mb: 2, mr: 3 }}
                                        variant="contained"
                                        color="error"
                                        onClick={() => remove(idx)}
                                        className="home-section-delete-button"
                                      >
                                        Delete Section
                                      </Button>
                                    )}
                                  </div>
                                  <div className="col">
                                    <div className="input-section">
                                      <FormLabel htmlFor={`sectionMeta.whyus_cols[${idx}].title`}>
                                        Column Title
                                      </FormLabel>
                                      <Field
                                        id={`sectionMeta.whyus_cols[${idx}].title`}
                                        name={`sectionMeta.whyus_cols[${idx}].title`}
                                        type="text"
                                        placeholder="Enter Title"
                                        className="input-style"
                                        required
                                      />
                                      <ErrorMessage
                                        name={`sectionMeta.whyus_cols[${idx}].title`}
                                        component="div"
                                        className="error-color"
                                      />
                                    </div>
                                    <div className="input-section">
                                      <FormLabel
                                        htmlFor={`sectionMeta.whyus_cols[${idx}].shortDescription`}
                                      >
                                        Column Description
                                      </FormLabel>
                                      <Field
                                        id={`sectionMeta.whyus_cols[${idx}].shortDescription`}
                                        name={`sectionMeta.whyus_cols[${idx}].shortDescription`}
                                        type="text"
                                        placeholder="Enter Description"
                                        className="input-style"
                                        required
                                      />
                                      <ErrorMessage
                                        name={`sectionMeta.whyus_cols[${idx}].shortDescription`}
                                        component="div"
                                        className="error-color"
                                      />
                                    </div>
                                    <div className="input-section">
                                      <FormLabel
                                        htmlFor={`sectionMeta.whyus_cols[${idx}].position`}
                                      >
                                        Column Position
                                      </FormLabel>
                                      <Field
                                        id={`sectionMeta.whyus_cols[${idx}].position`}
                                        name={`sectionMeta.whyus_cols[${idx}].position`}
                                        type="text"
                                        placeholder="Enter Position"
                                        className="input-style"
                                        required
                                      />
                                      <ErrorMessage
                                        name={`sectionMeta.whyus_cols[${idx}].position`}
                                        component="div"
                                        className="error-color"
                                      />
                                    </div>
                                    <Grid item xs={10} sm={10} md={6} lg={6} mt={2}>
                                      <FormLabel htmlFor={`sectionMeta.whyus_cols[${idx}].image`}>
                                        Upload Image
                                      </FormLabel>
                                      <TextField
                                        sx={{ mt: 1 }}
                                        id="file"
                                        name={`sectionMeta.whyus_cols[${idx}].icon`}
                                        type="file"
                                        required
                                        onChange={(e) => {
                                          const image = e.target.files[0];
                                          if (!validTypes.includes(image.type)) {
                                            toast.error(
                                              'Please select an image, allowed file types are .jpg, .jpeg, .png & .webp.'
                                            );
                                            return false;
                                          }
                                          let imgLen = image.size <= 2000000;
                                          if (!imgLen) {
                                            toast.error('Image Size Should be less than 2Mbs.');
                                            return false;
                                          }
                                          // setFieldValue(
                                          //   `sectionMeta.whyus_cols[${idx}].icon`,
                                          //   image
                                          // );
                                          console.log('sidasd', image);

                                          const fileReader = new FileReader();
                                          fileReader.onload = () => {
                                            if (fileReader.readyState === 2) {
                                              setFieldValue(
                                                `sectionMeta.whyus_cols[${idx}].icon`,
                                                fileReader.result
                                              );
                                            }
                                          };
                                          fileReader.readAsDataURL(image);
                                        }}
                                      />
                                    </Grid>
                                  </div>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        );
                      })}
                    {/* HTB - END */}
                  </Stack>
                  <Grid container>
                    <Grid xs={4} sm={4} md={3} lg={2} mt={3} item>
                      <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={loading}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                    <Grid xs={4} sm={4} md={3} lg={2} ml={2} mt={3} item>
                      <Button
                        fullWidth
                        size="large"
                        variant="contained"
                        color="error"
                        component={RouterLink}
                        to="/dashboard/why-us"
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
